import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { useAuth } from '../context/AuthContext';

// You can use any icon you like, here I use a simple unicode symbol or you can install react-icons
// npm install react-icons
import { FiLogOut } from 'react-icons/fi';  // Feather icons logout icon

import Logo from './Logo';
import ThemePicker from './ThemePicker';

function Topbar({ onLogoEasterEgg }) {
    const { user, logout } = useAuth();
    const theme = useTheme();

    return (
        <div style={{
            backgroundColor: theme.palette.primary.light,
            padding: '1rem 2rem',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            // No fixed height: sizes naturally from padding + the logo's own
            // height, so it can never clip regardless of the logo's size.
            flexShrink: 0,
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            position: 'sticky',
            top: 0,
            zIndex: 1000,
            justifyContent: 'space-between',
        }}>
            <Logo onSevenClicks={onLogoEasterEgg} />

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <ThemePicker />

                {/* Show logout icon only if logged in */}
                {user && (
                    <button
                        onClick={logout}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            color: 'white',
                            cursor: 'pointer',
                            fontSize: '1.5rem',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                        aria-label="Logout"
                        title="Logout"
                    >
                        <FiLogOut />
                    </button>
                )}
            </Box>
        </div>
    );
}

export default Topbar;
